export async function getArchitecture() {
    // https://developer.mozilla.org/en-US/docs/Web/API/NavigatorUAData/getHighEntropyValues
    // @ts-expect-error navigator.userAgentData is experimental not yet in the TS types
    if (typeof navigator?.userAgentData?.getHighEntropyValues === 'function') {
        // @ts-expect-error navigator.userAgentData is experimental not yet in the TS types
        const entropyValues = navigator.userAgentData.getHighEntropyValues(['architecture'])

        // When looking into the getHighEntropyValues API there were reports that it isn't
        // always a promise. Here we are wrapping it in a promise to ensure it is always
        // a promise.
        return Promise.resolve(entropyValues)
            .then(({ architecture }) => architecture)
            .catch(() => undefined)
    }

    return undefined
}
